import React from 'react';
import { Link } from 'react-scroll';
import './pages.css';
import './mshops.css';
import ArrowRight from '../Components/ArrowRights.js';
import bgmshops from '../images/bglegal.webp';

function TiendaNube() {
    return (
        <>
            <section className='mshops pagesIndex' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
                <div className='content'>
                    <div className='flexIndex'>
                        <div className='colIndex'>
                            <div className='brandEcommerce'><img src='../images/partners/tiendanubeevolution.webp' alt='tienda nube'></img></div>
                            <h2><span>ON BOARDING <i>-</i></span></h2>
                            <div className='textoWorks'>
                                <h3>Impulsa tu Marca al Siguiente Nivel con <strong>Index®</strong> y <strong>Tienda Nube</strong></h3>
                                <p>Contamos con 2 tipos de servicio:</p>
                            </div>
                        </div>
                        <div className='colIndex'>
                            <ArrowRight className="custom-arrow" />
                        </div>
                        <div className='colIndex'>
                            <ol className='flexIndex propuestas'>
                                <li>
                                    <h4>Lite</h4>
                                    <p>Creación del diseño a partir de una plantilla nativa de Tiendanube, incluyendo la adaptación de los colores y tipografías de acuerdo a la identidad
                                    actual de la marca.</p>
                                    <p className='remarcable'>Incluye integraciones nativas</p>
                                    <Link to="lite" smooth={true} duration={500}>VER MAS</Link>
                                </li>
                                <li>
                                    <h4>Pro</h4>
                                    <p>Para necesidades más complejas que requieren desarrollos o customizaciones personalizadas. Ajustes personalizados a través de códigos CSS o scripts.</p>
                                    <p className='remarcable'>Incluye integraciones y soluciones avanzadas</p>
                                    <Link to="lite" smooth={true} duration={500}>VER MAS</Link>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section id='lite' className='mshops pagesIndex planesIndex'>
                <div className='content'>
                    <div className='flexIndex'>
                        <div className='colIndex'>
                            <h2><span>LITE</span></h2> 
                            <p className='textosPlanes'>Crea tu tienda online de forma rápida y eficiente con <strong>LITE</strong>. Diseñamos e implementamos tu ecommerce utilizando un site builder, permitiéndote lanzar tu negocio sin complicaciones y con un layout profesional. <span>Ideal para quienes buscan una solución ágil, funcional y sin necesidad de código.</span></p>
                        </div>
                        <div className='colIndex'>
                            <h2><span>PRO</span></h2>
                            <p className='textosPlanes'>Lleva tu ecommerce al siguiente nivel con <strong>PRO</strong>. Aquí no hay límites: personalizamos tu tienda con desarrollos a medida, integraciones avanzadas y código optimizado para crear una experiencia de compra única y escalable. <span>Perfecto para marcas que buscan potencia, flexibilidad y un ecommerce sin restricciones.</span></p>
                        </div>
                    </div>
                    <div className='resumen'>
                        <h2><span>QUE INCLUYE .</span></h2> 
                        <h4><span>LITE . </span>PRO</h4>
                        <h5>Ambos plantes Incluyen</h5>
                        <div className='listadoResumen'>
                            <p>DISEÑO Y CREACIÓN DE TIENDA COMPLETA</p>
                            <p>DISEÑO DE BANNERS</p>
                            <p>ARMADO DEL MENÚ Y SUBMENÚES</p>
                            <p>DISEÑO CATEGORÍAS DESTACADAS</p>
                            <p>EDICIÓN DE TIPOGRAFÍAS Y COLORES</p>
                            <p>ARMADO DE PÁGINAS INSTITUCIONALES</p>
                            <p>ACOMPAÑAMIENTO DURANTE TODO EL PROCESO</p>
                            <p>VINCULACIÓN DE DOMINIO</p>
                            <p>SUSCRIPCIÓN</p>
                            <p>INTEGRACIÓN DE MEDIOS DE PAGO</p>
                            <p>INTEGRACIÓN DE MÉTODOS DE ENVÍO</p>
                            <p>CAPACITACIÓN SOBRE CÓMO ACTUALIZAR LA TIENDA</p>
                        </div>
                    </div>
                    <div className='legalesPlanes'>
                        <p>Recibimos todos los contenidos necesarios para comenzar el trabajo: Logo, fotos, textos, info de productos, otros.</p>
                        <p>Seleccionamos la Plantilla que mejor se adapte a las referencias y estilo de la Tienda.</p>
                        <p>La tipografía para el plan LITE son las que brinda TiendaNube desde el administrador de fuentes.</p>
                        <p>Enviamos una propuesta de customización de Diseño y diagrama de contenidos sobre la Plantilla elegida.</p>
                        <p>Realizamos una (1) tanda de ajustes y modificaciones sobre la propuesta enviada.</p>
                        <p>No Incluye cambios de precios, stock, descripciones ni fotos de productos</p>
                        <p>Completamos la Tienda con los ajustes/cambios enviados por el Cliente.</p>
                        <p>Una vez confirmado el saldo del trabajo, se entrega el acceso Administrador de la Tienda.</p>
                        <p>Ambos servicios incluyen la firma del estudio Index en el pie de página de la Tienda.</p>
                        <p>No incluyen desarrollo de Tiendas multi-idioma ni multi-moneda.</p>
                        <p>No incluyen la configuración de múltiples Dominios.</p>
                        <p>No incluyen los aranceles ni comisiones de Tiendanube ni comisiones de medios de Pago.</p>
                        <p>No incluyen el trámite ni los costos de registro ni renovación de Dominios.</p>
                        <p>El costo mensual y las condiciones del servicio son manejados por Tiendanube.</p>
                        <p>El tiempo estimado de trabajo corresponde a días hábiles, sin contar sábados, domingos ni feriados.</p>
                        <p>Todos nuestros Servicios detallados en este presupuesto son de pago única vez y se cobran 50% al comenzar el trabajo y 50% antes de la entrega de la Tienda completa.</p>
                        <p>Se emite Factura A</p>
                        <p>Forma de Pago: Transferencia o depósito Bancario.</p>
                    </div>
                </div>
            </section>
        </>
    );
}
export default TiendaNube;